import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import 'dayjs/locale/en' // Import locale if needed

export default function Date() {
  const formattedDate = dayjs().format('ddd - MMM D YYYY')
  return (
    <Typography variant="h6" component="h6">
      {formattedDate}
    </Typography>
  )
}
